<template>
  <div
    class="br-subleft overflow-y-auto supplier-left"
    :data-min="sideStatus"
    style="z-index: 1"
  >
    <div class="pd-x-10 mg-b-20">
      <h6
        class="
          tx-uppercase tx-14 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("distributor.条件筛选") }}
      </h6>
      <div class="mg-t-20 pd-x-10 mg-b-40">
        <div class="mg-b-10 form-group">
          <input
            type="text"
            :placeholder="$t('outside.客户名')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate()"
            v-model="keyDistributorName"
          />
        </div>
        <div class="mg-b-10 form-group">
          <input
            type="text"
            :placeholder="$t('distributor.客户联系人')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate()"
            v-model="keyContact"
          />
        </div>
      </div>
    </div>
    <button
      class="
        btn btn-primary search btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
      @click="filtrate"
    >
      {{ $t("distributor.筛 选") }}
    </button>
    <!-- todo3-原料供应商 -->
    <button
      @click="batchSearch('materialSuppliers')"
      class="
        btn btn-primary batchSearch btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
    >
      {{ $t("distributor.批量搜索") }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["sideStatus", "distributor_name", "cont"],
  data() {
    return {
      keyDistributorName: "",
      keyContact: "",
    };
  },
  watch: {
    distributor_name() {
      this.keyDistributorName = this.distributor_name;
    },
    cont() {
      this.keyContact = this.cont;
    },
  },
  methods: {
    batchSearch(key){
      this.$emit('batchSearch', key)
    },
    filtrate() {
      this.$emit("filtrate", this.keyDistributorName, this.keyContact);
    },
  },
};
</script>